// Campus photo for /colleges/kennesaw-state-university: CC BY 3.0, by Thejerm, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AKennesaw_State_Kennesaw_Hall.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/kennesaw-state-university/; credited under the photo.
const photo = {
    "slug": "kennesaw-state-university",
    "alt": "Kennesaw Hall seen across the campus green at Kennesaw State University in Kennesaw, Georgia",
    "src": "/colleges/kennesaw-state-university/campus-1600.webp",
    "srcSmall": "/colleges/kennesaw-state-university/campus-800.webp",
    "srcMid": "/colleges/kennesaw-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/kennesaw-state-university/og.jpg",
    "title": "Kennesaw State Kennesaw Hall",
    "author": "Thejerm",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AKennesaw_State_Kennesaw_Hall.jpg",
    "read": "2026-10-01"
};

export default photo;
